var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"iv-contact-detail iv-p-t-40"},[_c('h1',{staticClass:"iv-text-center iv-fc-85 iv-m-b-24 iv-fs-24"},[_vm._v("xxxxxx组织目标")]),_c('p',{staticClass:"iv-text-center iv-fc-45 iv-m-b-24 iv-fs-16"},[_vm._v("发布日期：2022-10-10")]),_c('div')])
}]

export { render, staticRenderFns }